import api from './api';

/*
 * «Роли» как центральная admin-поверхность (ТЗ v4 §29 ROLES-NOTIFY01 и §31
 * NAV-ENTITLEMENTS01).
 *
 * Все ответы — read model backend: доступные пользователю локации/камеры,
 * эффективное состояние каналов и navigation entitlements. Фронт ничего из
 * этого не выводит сам: ACL и «что кому видно» остаются на сервере.
 *
 * Массовое включение/выключение уведомлений — один POST .../bulk на
 * пользователя и направление, а не по запросу на камеру: backend сам
 * применяет изменение ко всем текущим доступным камерам и возвращает счётчики.
 */

export const listRoleNotificationUsers = () =>
  api.get('/admin/roles/notification-users').then((response) => response.data);

export const getRoleUserEventNotifications = (userId) =>
  api.get(`/admin/roles/users/${userId}/event-notifications`).then((response) => response.data);

export const bulkRoleUserEventNotifications = (userId, body) =>
  api.post(`/admin/roles/users/${userId}/event-notifications/bulk`, body).then((response) => response.data);

export const getNavigationTree = () =>
  api.get('/admin/roles/navigation-tree').then((response) => response.data);

export const getRoleUserNavigation = (userId) =>
  api.get(`/admin/roles/users/${userId}/navigation`).then((response) => response.data);

/** mode=replace + expected_version: конкурентная правка ловится как 409. */
export const updateRoleUserNavigation = (userId, body) =>
  api.put(`/admin/roles/users/${userId}/navigation`, body).then((response) => response.data);

export const resetRoleUserNavigation = (userId, expectedVersion) =>
  api.delete(`/admin/roles/users/${userId}/navigation`, { params: { expected_version: expectedVersion } })
    .then((response) => response.data);

/** Навигация текущего пользователя: источник истины для сайдбара. */
export const getMyNavigation = () =>
  api.get('/me/navigation').then((response) => response.data);

export const getMyEntitlements = () =>
  api.get('/me/entitlements').then((response) => response.data);
